    <template>
        <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" persistent
            transition-show="scale" transition-hide="scale" maximized>
            <q-card class="excel-importer-form" style="display: flex; flex-direction: column; height: 100vh;">
                <!-- Header mejorado -->
                <q-toolbar class="bg-primary text-white">
                    <q-toolbar-title>
                        <div class="row items-center q-gutter-sm">
                            <q-icon name="upload_file" size="28px" />
                            <div>
                                <div class="text-h6">Importar desde Excel</div>
                                <div class="text-caption text-white-7">Configure los datos comunes y agregue productos</div>
                            </div>
                        </div>
                    </q-toolbar-title>
                    <q-btn flat round dense icon="close" @click="$emit('update:modelValue', false)">
                        <q-tooltip>Cerrar</q-tooltip>
                    </q-btn>
                </q-toolbar>

                <div class="row no-wrap content-scrollable" style="flex: 1; overflow: hidden;">
                    <!-- Columna principal: Formulario -->
                    <div class="col-12 col-md-8 q-pa-md scroll" style="height: 100%; overflow-y: auto;">
                        <!-- Sección: Información del Producto -->
                        <q-expansion-item default-opened icon="info" label="Información del Producto"
                            caption="Configure empresa, alícuota, tipo de venta y ubicación"
                            header-class="bg-grey-2 text-primary text-weight-medium"
                            class="q-mb-md rounded-borders overflow-hidden">
                            <q-card flat bordered>
                                <q-card-section>
                                    <ProductosCommon
                                        v-model:empresa-id="commonForm.empresa_id"
                                        v-model:alicuota-id="commonForm.alicuota_id"
                                        v-model:tipo-venta-id="commonForm.tipo_venta_id"
                                        v-model:ubicacion-id="commonForm.ubicacion_id"
                                        :res="validationRes" />
                                </q-card-section>
                            </q-card>
                        </q-expansion-item>

                        <!-- Sección: Tabla de productos -->
                        <q-expansion-item default-opened icon="table_chart" label="Productos a Importar"
                            caption="Ingrese los productos con sus cantidades y descuentos"
                            header-class="bg-grey-2 text-primary text-weight-medium"
                            class="q-mb-md rounded-borders overflow-hidden">
                            <q-card flat bordered>
                                <q-card-section>
                                    <div class="jss-wrapper">
                                        <Spreadsheet ref="spreadsheet"
                                            :onafterchanges="setLoading(false)"
                                            :onpaste="onPaste"
                                            >
                                            <Worksheet
                                                :data="spreadsheetData"
                                                :columns="spreadsheetColumns"
                                                :allowInsertColumn="false"
                                                :allowDeleteColumn="false"
                                                />
                                        </Spreadsheet>
                                        <q-inner-loading :showing="loading">
                                            <q-spinner-hourglass size="50px" color="primary" />
                                        </q-inner-loading>
                                    </div>
                                </q-card-section>
                            </q-card>
                        </q-expansion-item>
                    </div>

                    <!-- Columna lateral: Resumen -->
                    <div class="col-12 col-md-4 bg-grey-1 q-pa-md" style="height: 100%; overflow-y: auto;">
                        <div class="sticky-top">
                            <q-card class="shadow-2">
                                <q-card-section class="bg-primary text-white">
                                    <div class="text-h6">
                                        <q-icon name="receipt_long" class="q-mr-sm" />
                                        Resumen de Importación
                                    </div>
                                </q-card-section>

                                <q-separator />

                                <q-card-section>
                                    <div class="q-gutter-sm">
                                        <div class="row items-center justify-between">
                                            <span class="text-grey-7">Total productos:</span>
                                            <span class="text-weight-bold">{{ totalProductos }}</span>
                                        </div>

                                        <q-separator />

                                        <div class="row items-center justify-between">
                                            <span class="text-grey-7">Subtotal:</span>
                                            <span class="text-weight-bold">{{ numberFormat(subtotal, false) }}</span>
                                        </div>

                                        <div class="row items-center justify-between text-negative">
                                            <span>Descuento total:</span>
                                            <span class="text-weight-bold">-{{ numberFormat(totalDescuento, false) }}</span>
                                        </div>

                                        <q-separator class="q-my-md" />

                                        <div class="row items-center justify-between text-h6 text-primary">
                                            <span class="text-weight-bold">Total:</span>
                                            <span class="text-weight-bold">{{ numberFormat(total, false) }}</span>
                                        </div>
                                    </div>
                                </q-card-section>

                                <q-separator />

                                <q-card-section class="bg-blue-1">
                                    <div class="text-caption text-grey-7">
                                        <q-icon name="info" size="16px" class="q-mr-xs" />
                                        Los totales se actualizan automáticamente al agregar productos
                                    </div>
                                </q-card-section>
                            </q-card>

                            <!-- Tips -->
                            <q-card class="q-mt-md">
                                <q-card-section>
                                    <div class="text-weight-medium q-mb-sm">
                                        <q-icon name="tips_and_updates" color="amber" class="q-mr-xs" />
                                        Consejos útiles
                                    </div>
                                    <ul class="text-caption text-grey-7 q-pl-md q-my-none">
                                        <li>Configure primero la información común</li>
                                        <li>Ingrese el código del producto en la primera columna</li>
                                        <li>Los precios se cargan automáticamente</li>
                                        <li>Puede agregar/eliminar filas según necesite</li>
                                    </ul>
                                </q-card-section>
                            </q-card>
                        </div>
                    </div>
                </div>

                <q-separator />

                <!-- Footer con acciones -->
                <q-card-actions class="q-pa-md actions-fixed" style="flex-shrink: 0;">
                    <div class="row full-width q-gutter-sm">
                        <div class="col">
                            <q-btn outline label="Cancelar" color="grey-7" icon="close"
                                @click="$emit('update:modelValue', false)" class="full-width" />
                        </div>
                        <div class="col">
                            <q-btn unelevated label="Importar Productos" color="primary"
                                icon="add_shopping_cart" @click="handleImport"
                                :disable="!canImport" class="full-width">
                                <q-tooltip v-if="!canImport">Complete la información del producto para continuar</q-tooltip>
                            </q-btn>
                        </div>
                    </div>
                </q-card-actions>
            </q-card>
        </q-dialog>
    </template>

    <script setup>
    import { ref, nextTick, computed, reactive } from "vue";
    import { Spreadsheet, Worksheet } from "@jspreadsheet-ce/vue";
    import "jsuites/dist/jsuites.css";
    import "jspreadsheet-ce/dist/jspreadsheet.css";
    import "@/css/jspreadsheet-overrides.css";
    import PrecioListaService from "@/services/PrecioListaService";
    import numberFormat from '@/helpers/numberFormat.ts';
    import ProductosCommon from '@/pages/Productos/components/tipo/components/ProductosCommon.vue';

    const loading = ref(false);
    const props = defineProps({
        modelValue: {
            type: Boolean,
            default: false,
        },
    });

    // Formulario común
    const commonForm = reactive({
        empresa_id: null,
        alicuota_id: 3,
        tipo_venta_id: null,
        ubicacion_id: null,
    });

    // Validación básica
    const validationRes = ref({
        getErrors: () => [],
    });

    const spreadsheetData = ref([
        ["", "", "", "", "", "", "", ""],
        ["", "", "", "", "", "", "", ""],
        ["", "", "", "", "", "", "", ""],
        ["", "", "", "", "", "", "", ""],
        ["", "", "", "", "", "", "", ""],
    ]);

    const spreadsheetColumns = ref([
        { title: "Producto", width: 200 },
        { title: "Descripción", width: 300, readOnly: true },
        { title: "Cant Paneles", width: 100, type: "numeric" },
        { title: "Largo Panel", width: 100, type: "numeric" },
        { title: "Descuento %", width: 100, type: "numeric" },
        { title: "Precio", width: 100, type: "text", readOnly: true },
        { title: "Ancho", width: 100, type: "text", readOnly: true },
        { title: "Acciones", width: 100, type: "html", readOnly: true },
    ]);

    const setLoading = (value) => loading.value = value;

    const onPaste = async (worksheet, pastedInfo) => {
        // Filtrar solo los productos pegados en la columna "Producto" (x === 0)
        console.log('Pasted info:', pastedInfo);
        const productosData = pastedInfo.filter(item => {
            const col = parseInt(item.x);
            return col === 0 && item.value && item.value.trim() !== '';
        });

        if (productosData.length === 0) return;

        // Extraer productos únicos
        const uniqueProducts = [...new Set(productosData.map(item => item.value))];

        // Mostrar loading
        loading.value = true;

        try {
            // Hacer llamadas paralelas para cada producto único
            const productDataPromises = uniqueProducts.map(productCode =>
                PrecioListaService.getItemData(productCode)
                    .then(data => ({ productCode, data }))
                    .catch(err => ({ productCode, data: null, error: err }))
            );

            const results = await Promise.all(productDataPromises);

            // Crear un mapa de producto -> datos
            const productMap = new Map();
            results.forEach(({ productCode, data }) => {
                if (data && data.label) {
                    productMap.set(productCode, data);
                }
            });

            // Actualizar todas las filas con los datos correspondientes
            productosData.forEach(item => {
                // Parsear coordenadas: jSpreadsheet usa formato "XY" donde la fila = X + Y
                const row = parseInt(item.y.charAt(0)) + parseInt(item.y.charAt(1));
                const productData = productMap.get(item.value);

                if (productData) {
                    const { label, precio, ancho } = productData;
                    // Usar setRowData para actualizar toda la fila de una vez
                    // null = no cambiar esa columna
                    worksheet.setRowData(row, [
                        null,                           // Col 0: Producto (ya pegado)
                        label,                          // Col 1: Descripción
                        null,                           // Col 2: Cant Paneles
                        null,                           // Col 3: Largo Panel
                        null,                           // Col 4: Descuento %
                        numberFormat(precio, false),    // Col 5: Precio
                        numberFormat(ancho, true),      // Col 6: Ancho
                        null                            // Col 7: Acciones
                    ], true); // force=true para actualizar columnas readonly
                }
            });

            await nextTick();
        } catch (error) {
            console.error('Error al procesar productos pegados:', error);
        } finally {
            loading.value = false;
        }
    };

    // Computados para resumen
    const totalProductos = computed(() => {
        return spreadsheetData.value.filter(row => row[0] && row[0] !== '').length;
    });

    const subtotal = computed(() => {
        return spreadsheetData.value.reduce((sum, row) => {
            const cantPaneles = parseFloat(row[2]) || 0;
            const largoPieza = parseFloat(row[3]) || 0;
            const precio = parseFloat(String(row[5]).replace(/[^0-9.-]/g, '')) || 0;
            const ancho = parseFloat(String(row[6]).replace(/[^0-9.-]/g, '')) || 0;

            const cantidad = cantPaneles * largoPieza * ancho;
            return sum + (cantidad * precio);
        }, 0);
    });

    const totalDescuento = computed(() => {
        return spreadsheetData.value.reduce((sum, row) => {
            const cantPaneles = parseFloat(row[2]) || 0;
            const largoPieza = parseFloat(row[3]) || 0;
            const precio = parseFloat(String(row[5]).replace(/[^0-9.-]/g, '')) || 0;
            const ancho = parseFloat(String(row[6]).replace(/[^0-9.-]/g, '')) || 0;
            const descuento = parseFloat(row[4]) || 0;

            const cantidad = cantPaneles * largoPieza * ancho;
            const subtotalRow = cantidad * precio;
            return sum + (subtotalRow * (descuento / 100));
        }, 0);
    });

    const total = computed(() => {
        return subtotal.value - totalDescuento.value;
    });

    const canImport = computed(() => {
        return commonForm.empresa_id &&
            commonForm.alicuota_id &&
            commonForm.tipo_venta_id &&
            commonForm.ubicacion_id &&
            totalProductos.value > 0;
    });

    const handleImport = () => {
        // Aquí iría la lógica de importación
        console.log('Importando productos...', {
            commonForm,
            products: spreadsheetData.value
        });
        // Emitir evento o llamar al store
    };
    </script>

    <style lang="scss" scoped>
    @use 'sass:color';

    .excel-importer-form {
        border-radius: 16px;
        overflow: hidden;

        .text-white-7 {
            color: rgba(255, 255, 255, 0.7);
        }

        .content-scrollable {
            flex: 1;
            overflow: hidden;
        }

        .actions-fixed {
            flex-shrink: 0;
            box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
        }

        .sticky-top {
            position: sticky;
            top: 16px;
        }

        // Scrollbar personalizado
        ::-webkit-scrollbar {
            width: 8px;
        }

        ::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }

        ::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;

            &:hover {
                background: #555;
            }
        }
    }

    // Expansion items
    :deep(.q-expansion-item) {
        border: 1px solid rgba(0, 0, 0, 0.08);
        transition: all 0.3s ease;

        &.q-expansion-item--expanded {
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }

        .q-expansion-item__container {
            .q-item {
                min-height: 56px;
            }
        }
    }

    // jSpreadsheet wrapper
    :deep(.jss-wrapper) {
        position: relative;
        min-height: 400px;

        td.readonly{
            background-color: #f5f5f5 !important;
            color: #000000 !important;
        }

        .spinner-cell {
            display: inline-block;
            width: 20px;
            height: 20px;
            border: 3px solid #f3f3f3;
            border-top: 3px solid #1976d2;
            border-radius: 50%;
            animation: spin-cell 1s linear infinite;
        }

        @keyframes spin-cell {
            0% {
                transform: rotate(0deg);
            }

            100% {
                transform: rotate(360deg);
            }
        }

        .flex {
            display: flex;
        }

        .items-center {
            align-items: center;
        }

        .justify-center {
            justify-content: center;
        }

        // Estilos para la tabla
        .jss_content {
            border-radius: 8px;
            overflow: hidden;
        }

        .jss_worksheet {
            border-collapse: separate;
            border-spacing: 0;

            thead tr td {
                background-color: #1976d2 !important;
                color: white !important;
                font-weight: 600;
                text-align: center;
                padding: 12px 8px;
                border-bottom: 2px solid #1565c0;
            }

            tbody tr {
                &:hover {
                    background-color: rgba(25, 118, 210, 0.05);
                }

                td {
                    padding: 8px;
                    border-bottom: 1px solid #e0e0e0;
                }
            }
        }
    }

    // Responsive
    @media (max-width: 1023px) {
        .excel-importer-form {
            border-radius: 0;

            .sticky-top {
                position: relative;
                top: 0;
            }
        }
    }
    </style>
